import React from 'react';

export interface LinkProps {
  linkTextContent: string,
  href: string,
  onClick: () => void
}

const Link : React.FC<LinkProps> = ({
  linkTextContent,
  href,
  onClick,
}) => (
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  <a
    className="link"
    href={href}
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
    dangerouslySetInnerHTML={{ __html: linkTextContent }}
  />
);

export default Link;
